/** Define how letter mailings are priced */
const letterPricing = {
	base: 1.05,
	perPage: 0.15,
	additionalPerPageInColor: 0.1,
	minimum: 1.25,
};

export default letterPricing;
